
import { useEffect, useState } from 'react';
import '../../App.css';
import './PerfilPage.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Navbar from '../../components/PublicUi/PublicNavbar/PublicNavbar';
import Grid from '../../components/PublicUi/PublicGrid/PublicGrid';
import PublicPerfilForm from '../../components/PublicForms/PublicPerfilForm';
import { usePermissao } from '../../hooks/usePermissao';
import CadastrosService from '../../services/CadastrosService';
import CadastrosInternosService from '../../services/CadastrosInternosService';
import AgendamentosService from '../../services/AgendamentosService';

import PerfilIcon from '../../assets/icons/perfil.png';
import HistoricoIcon from '../../assets/icons/historico.png';

export default function PerfilPage() {

  const { acessoPermissao } = usePermissao();
  const permissaoEditar = acessoPermissao("cadastros", "atualizar");

  const [perfil, setPerfil] = useState(null);
  const [agendamentos, setAgendamentos] = useState([]);
  const [formAberto, setFormAberto] = useState(false);
  const [retorno, setRetorno] = useState(null);
  const [erro, setErro] = useState(null);
  
  const colunasPerfil = [
    { header: 'Nome', field: 'NOME' },
    { header: 'Login', field: 'LOGIN' },
    { header: 'E-mail', field: 'EMAIL' },
    { header: 'Celular', field: 'CELULAR' }
  ];

  const colunasAgendamento = [
    { header: 'Data', field: 'DATA' },
    { header: 'Hora', field: 'HORARIO' },
    { header: 'Serviço', field: 'DESCRICAO' },
    { header: 'Status', field: 'STATUS'}
  ];

  useEffect(() => {
    async function carregarDados() {
      try {
        const userId = localStorage.getItem('UserId');
        if (!userId) return;

        const perfilResponse = await CadastrosInternosService.getById(userId);
        setPerfil(perfilResponse);

        const historico = await AgendamentosService.getHistoricoByCadastro(userId);
        setAgendamentos(historico || []);
      } catch (error) {
        console.error('Erro ao carregar dados do perfil:', error);
      }
    }

    carregarDados();
  }, []);

  const abrirFormularioEdicao = () => {
    if (!permissaoEditar) return;
    setFormAberto(true);
  };

  const actionsNavbar = [];
  if (permissaoEditar) actionsNavbar.push("Atualizar Cadastro");

  const handleNavbarAction = (acao) => {
    if (acao === 'Atualizar Cadastro') {
      abrirFormularioEdicao();
    }
  };

  return (
    <div className="Perfil-container">
      <Header />

      <article>
        <div className="Perfil">
          <div className="Perfil-header">
            <img src={PerfilIcon} alt="Perfil" />
            Dados Cadastrais
          </div>

          <div className="Perfil-linha" />


          {retorno && (
            <div className="mensagem-sucesso">
              {retorno}
            </div>
          )}

          {erro && (
            <div className="mensagem-erro">
              {erro}
            </div>
          )}


          {formAberto && perfil && (
            <PublicPerfilForm
              perfil={perfil}
              onClose={() => setFormAberto(false)}
              //onSucesso={() => setFormAberto(false)}
              onSucesso={(mensagem) => {
                setRetorno(mensagem);
                setErro(null);
                setFormAberto(false);
              }}
            />
          )}

          <Navbar
            actions={actionsNavbar}
            onActionClick={handleNavbarAction}
          />

          {perfil && (
            <Grid
              columns={colunasPerfil}
              data={[perfil]}
              onRowClick={abrirFormularioEdicao}
            />
          )}

          <div className="Perfil-historico">
            <img src={HistoricoIcon} alt="Histórico" />
            Histórico de Agendamentos
          </div>

          {agendamentos.length > 0 ? (
            <Grid
              columns={colunasAgendamento}
              data={agendamentos}
            />
          ) : (
            <p>Ainda não há agendamentos.</p>
          )}
        </div>
      </article>

      <Footer />
    </div>
  );
}
